import Vue from 'vue';
import VueRouter from 'vue-router';
import { base } from '~/js/thelist/api';
import List from '~/js/thelist/components/List.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/:year?/:region?/:industry?',
        component: List
    }
];


export default new VueRouter({
    base,
    routes,
    mode: 'history',
    linkActiveClass: 'state-active',
    linkExactActiveClass: 'state-active state-active--exact'
});



// WEBPACK FOOTER //
// ./assets/js/thelist/router.js